import { RightSideBloodOrderTranslations } from "./types";

export const enTranslations: RightSideBloodOrderTranslations = {
    selectedItems: "Selected Items",
    reason: "Reason for Blood Order",
    submitOrder: "Submit Order"
};